import request from '@/services/interceptor.js'


export const get_file = (data) => {
    return request({
        url: '/archivio',
        method: 'post',
        data: data,
    })
}

export const getDettaglioFile = (data) => {
    return request({
        url: '/archivio/dettaglio',
        method: 'post',
        data: data,
    })
}

export const get_estensioni = (data) => {
    return request({
        url: '/archivio/estensioni',
        method: 'post',
        data: data,
    })
}

export const download_file = (par) => {
    return request({
        url: '/archivio/download' + par,
        method: 'get',
        responseType: 'blob'
    })
};


export const carica_file = (data, par) => {
    return request({
        url: '/archivio/upload' + par,
        method: 'post',
        data: data,
    })
}

export const elimina_file = (data, par) => {
    return request({
        url: '/archivio/delete' + par,
        method: 'delete',
        data: data,
    })
}

export const crea_cartella = (data, par) => {
    return request({
        url: '/archivio/cartella' + par,
        method: 'post',
        data: data,
    })
}

export const elimina_cartella = (par) => {
    return request({
        url: '/archivio/cartella' + par,
        method: 'delete',
    })
}

export const rinomina_cartella = (data, par) => {
    return request({
        url: '/archivio/rinomina/cartella' + par,
        method: 'post',
        data: data,
    })
}